import { render, staticRenderFns } from "./AddStockModal.vue?vue&type=template&id=35bab212&scoped=true"
import script from "./AddStockModal.vue?vue&type=script&lang=js"
export * from "./AddStockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bab212",
  null
  
)

export default component.exports